// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"688c8e1c","577":"ad1238f0"}[chunkId] + ".chunk.js";
};